import {NgModule} from '@angular/core';
import {Routes} from "@angular/router";
import {AdminGuardProvider} from "@core/security/admin-guard.provider";
import {ShareModule} from "@share/share.module";
import {ComptabiliteComptesBancairesComponent} from "app/components/admin/comptabilite/comptes-bancaires/comptabilite-comptes-bancaires.component";
import {AdminComptabiliteComponent} from "@components/admin/comptabilite/admin-comptabilite.component";
import {ComptabiliteComptesBancairesModule,comptabiliteComptesBancairesRoutes} from "@components/admin/comptabilite/comptes-bancaires/comptabilite-comptes-bancaires.module";
import {ComptabiliteExercicesPeriodesComponent} from 'app/components/admin/comptabilite/exercices-periodes/comptabilite-exercices-periodes.component';
import {comptabiliteExercicesPeriodesRoutes} from "@components/admin/comptabilite/exercices-periodes/comptabilite-exercices-periodes.module";
import {ComptabiliteModeRemboursementModule} from "@components/admin/comptabilite/mode-remboursement/comptabilite-mode-remboursement.module";
import {ComptabiliteModeRemboursementComponent} from "@components/admin/comptabilite/mode-remboursement/comptabilite-mode-remboursement.component";
import {IbanPipe,NgxIbanModule} from "ngx-iban";
import {ComptabilitePlanComptableModule,comptabilitePlanComptableRoutes} from "@components/admin/comptabilite/plan-comptable/comptabilite-plan-comptable.module";
import {PlanComptableComponent} from "@components/admin/comptabilite/plan-comptable/plan-comptable.component";
import {DroitAdmin} from "@core/security/droit-admin";
import {ComptabiliteLotsComptablesModule,comptabiliteLotsComptablesRoutes} from "./lots-comptables/comptabilite-lots-comptables.module";
import {ComptabiliteLotsComptablesComponent} from "./lots-comptables/comptabilite-lots-comptables.component";

/**
 * Routes du module d'administration de la comptabilité
 */
export const adminComptabiliteRoutes: Routes = [
	{
		path: 'ComptesBancaires',
		component: ComptabiliteComptesBancairesComponent,
		canActivate: [AdminGuardProvider],
		children: comptabiliteComptesBancairesRoutes
	},{
		path: 'ExercicesPeriodes',
		component: ComptabiliteExercicesPeriodesComponent,
		canActivate: [AdminGuardProvider],
		children: comptabiliteExercicesPeriodesRoutes
	},{
		path: 'ModeRemboursement',
		component: ComptabiliteModeRemboursementComponent,
		canActivate: [AdminGuardProvider],
		data : { sousAdminCredentials: [DroitAdmin.DROIT_MODE_REMBOURSEMENT] }
	},{
		path: 'PlanComptable',
		component: PlanComptableComponent,
		canActivate: [AdminGuardProvider],
		data: { sousAdminCredentials: [DroitAdmin.DROIT_COMPTE_GESTION] },
		children: comptabilitePlanComptableRoutes
	},{
		path: 'LotsComptables',
		component: ComptabiliteLotsComptablesComponent,
		canActivate: [AdminGuardProvider],
		children: comptabiliteLotsComptablesRoutes
	},{
		path: '',
		redirectTo: 'ComptesBancaires',
		pathMatch: 'full'
	},{
		path: '**',
		redirectTo: 'ComptesBancaires'
	}
];

/**
 * Module d'administration de la comptabilité
 *
 * @author Alexis BOUVARD
 * @date 18/04/2023
 */
@NgModule({
	imports: [
		ShareModule,
		ComptabiliteComptesBancairesModule,
		ComptabiliteModeRemboursementModule,
		ComptabilitePlanComptableModule,
		ComptabiliteLotsComptablesModule,
		NgxIbanModule,
	],
	declarations: [
		AdminComptabiliteComponent,
	],
	providers: [IbanPipe]
})
export class AdminComptabiliteModule {
}
